import React from "react";
import ProductBox$ from "@deosite/components-new/ProductBox";
const ProductBox = props => <ProductBox$ {...props} />;

export default ProductBox;
